import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const SELECTED = [
  {
    title: "The Pink Cowboy",
    series: "Black Western",
    slug: "black-western",
    id: "pink-cowboy",
    image:
      "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/8e43o2fp_Pink%20Cowboy.jpg",
    feature: true,
  },
  {
    title: "Put On the Red Dress",
    series: "Figurative Contemporary",
    slug: "figurative-contemporary",
    id: "put-on-the-red-dress",
    image:
      "https://customer-assets.emergentagent.com/job_gallerystore/artifacts/9guy62pq_Put%20On%20the%20Red%20Dress.JPG",
  },
  {
    title: "You Won't Buff My Flow",
    series: "Small Works · New",
    slug: "small-works",
    id: "sw-the-buffalo",
    image:
      "https://customer-assets-jai6qajn.emergentagent.net/job_black-western-studio/artifacts/2ld8bysl_IMG_2197.webp",
  },
];

export default function SelectedWorks() {
  return (
    <section
      className="border-t border-border"
      data-testid="selected-works"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <header className="flex items-end justify-between gap-6 mb-12 md:mb-16">
          <div>
            <p className="label mb-3">001 — Selected Works</p>
            <h2 className="serif text-4xl md:text-5xl tracking-tight font-light">
              A measured introduction.
            </h2>
          </div>
          <Link
            to="/work"
            className="hidden md:inline-flex items-center gap-2 label link-underline"
            data-testid="selected-view-all"
          >
            View all <ArrowUpRight className="h-3.5 w-3.5" />
          </Link>
        </header>

        <div className="grid grid-cols-12 gap-6 md:gap-8">
          <Link
            to={`/work/${SELECTED[0].slug}/${SELECTED[0].id}`}
            className="art-card col-span-12 md:col-span-7 group"
            data-testid="selected-piece-1"
          >
            <div className="aspect-[5/6] overflow-hidden bg-[hsl(var(--surface))]">
              <img
                src={SELECTED[0].image}
                alt={SELECTED[0].title}
                className="art-img w-full h-full object-cover"
              />
            </div>
            <Caption work={SELECTED[0]} />
          </Link>

          <div className="col-span-12 md:col-span-5 grid grid-cols-1 gap-6 md:gap-8">
            {SELECTED.slice(1).map((w, i) => (
              <Link
                key={w.title}
                to={`/work/${w.slug}/${w.id}`}
                className="art-card group"
                data-testid={`selected-piece-${i + 2}`}
              >
                <div className="aspect-[4/3] overflow-hidden bg-[hsl(var(--surface))]">
                  <img
                    src={w.image}
                    alt={w.title}
                    className="art-img w-full h-full object-cover"
                  />
                </div>
                <Caption work={w} />
              </Link>
            ))}
          </div>
        </div>

        <div className="mt-10 md:hidden">
          <Link to="/work" className="label link-underline">
            View all →
          </Link>
        </div>
      </div>
    </section>
  );
}

function Caption({ work }) {
  return (
    <div className="mt-4 flex items-baseline justify-between gap-4">
      <div>
        <h3 className="serif italic text-xl md:text-2xl leading-tight">
          {work.title}
        </h3>
        <p className="label mt-1">{work.series}</p>
      </div>
      <ArrowUpRight className="h-4 w-4 mt-2 shrink-0 opacity-60 group-hover:opacity-100 transition-opacity" />
    </div>
  );
}
